// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-category-index-jsx": () => import("./../../../src/templates/category/index.jsx" /* webpackChunkName: "component---src-templates-category-index-jsx" */),
  "component---src-templates-page-index-jsx": () => import("./../../../src/templates/page/index.jsx" /* webpackChunkName: "component---src-templates-page-index-jsx" */),
  "component---src-templates-product-index-jsx": () => import("./../../../src/templates/product/index.jsx" /* webpackChunkName: "component---src-templates-product-index-jsx" */)
}

